<template>
  <div
    class="comp_programList"
    :class="[
      themeClass === 'onlyDisplay' ? 'onlyDisplay' : '',
      viewMode,
      data && data.length > 3 ? 'alignTop' : 'alignCenter',
    ]"
  >
    <div
      class="program_list_item"
      :class="[chooseState, , item.isChooseFlag ? 'chooseAct' : '']"
      v-for="item in data"
      :key="item.gameId"
      @click="goDetail(item)"
    >
      <span class="item_matchLeft">
        <span class="matchLeft_colum1">
          <template v-if="viewMode && viewMode === 'shareAfterView'">
            <span
              class="matchLeft_colum1_row1"
              v-text="_valPerFormatHandler(`${item.date} ${item.time}`)"
            ></span>
          </template>
          <template v-else>
            <span
              class="matchLeft_colum1_row1"
              v-text="_valPerFormatHandler(item.time)"
            ></span>
          </template>
        </span>
      </span>
      <span class="item_matchCenter combat">
        <span class="matchCenter_colum1">
          <span class="matchCenter_colum1_row">
            <span
              class="delegationName"
              v-text="_valPerFormatHandler(item.description)"
            ></span>
          </span>
        </span>
      </span>
      <span class="item_matchRight">
        <template
          v-if="themeClass !== 'onlyDisplay' && chooseState === 'default'"
        >
          <span
            class="matchRight_btn"
            @click.stop="clickRightBtn(item, 'edit')"
          >
            <span class="iconBox">
              <svg
                t="1700212308412"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="7759"
                width="70%"
                height="70%"
                class="svg_icon"
              >
                <path
                  d="M775.84 392.768l-155.2-172.352L160.768 643.264l-38.368 187.936 190.56-12.832zM929.952 229.952l-131.2-150.944-0.288-0.32a16 16 0 0 0-22.592-0.96l-131.168 120.576 155.168 172.352 128.832-118.464a15.936 15.936 0 0 0 1.248-22.24zM96 896h832v64H96z"
                  p-id="7760"
                ></path>
              </svg>
            </span>
          </span>
          <span
            class="matchRight_btn"
            @click.stop="clickRightBtn(item, 'remove')"
          >
            <span class="iconBox">
              <svg
                t="1712564502007"
                class="svg_icon"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="6028"
                width="80%"
                height="80%"
              >
                <path
                  d="M202.666667 256h-42.666667a32 32 0 0 1 0-64h704a32 32 0 0 1 0 64H266.666667v565.333333a53.333333 53.333333 0 0 0 53.333333 53.333334h384a53.333333 53.333333 0 0 0 53.333333-53.333334V352a32 32 0 0 1 64 0v469.333333c0 64.8-52.533333 117.333333-117.333333 117.333334H320c-64.8 0-117.333333-52.533333-117.333333-117.333334V256z m224-106.666667a32 32 0 0 1 0-64h170.666666a32 32 0 0 1 0 64H426.666667z m-32 288a32 32 0 0 1 64 0v256a32 32 0 0 1-64 0V437.333333z m170.666666 0a32 32 0 0 1 64 0v256a32 32 0 0 1-64 0V437.333333z"
                  p-id="6029"
                ></path>
              </svg>
            </span>
          </span>
        </template>
        <template v-if="viewMode && viewMode === 'shareAfterView'">
          <span
            class="channelName"
            v-text="_valPerFormatHandler(item.channelName)"
          ></span>
        </template>
      </span>
      <span class="item_absChoose" v-show="chooseState === 'choose'">
        <span class="checkbox_item">
          <svg
            t="1693726421166"
            class="icon"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="21127"
            width="80%"
            height="80%"
          >
            <path
              d="M892.064 261.888a31.936 31.936 0 0 0-45.216 1.472L421.664 717.248l-220.448-185.216a32 32 0 1 0-41.152 48.992l243.648 204.704a31.872 31.872 0 0 0 20.576 7.488 31.808 31.808 0 0 0 23.36-10.112L893.536 307.136a32 32 0 0 0-1.472-45.248z"
              p-id="21128"
            ></path>
          </svg>
        </span>
      </span>
    </div>
  </div>
</template>

<script>
import cup_base_data_mixin from '@mixins/cup_base_data'
export default {
  name: 'commonPage_comp_programList',
  mixins: [cup_base_data_mixin],
  props: {
    data: {
      type: Array,
      default: () => {
        return []
      },
    },
    detailPathName: {
      type: [String, Array],
      default: '',
    },
    chooseState: {
      type: String,
      default: 'default', //['default', 'choose', 'none'] none：没有鼠标经过效果
    },
    localStorageName: {
      type: String,
      default: '',
    },
    localStorageSaveDate: {
      type: String,
      default: '',
    },
    themeClass: {
      // 不同页面视图的展示
      type: String,
      default: '',
    },
    viewMode: {
      // 相同页面，控制不同视图的展示;这个就是matchListViewMode中的元素
      type: String,
      default: '',
    },
    channelType: {
      type: String,
      default: 'radio', //频道选择的模式，radio:单选；checkbox:多选
    },
  },
  data() {
    return {}
  },
  methods: {
    goDetail(item) {
      console.debug(item, this.openNewWeb, this.$dynamicConfig)
      if (this.chooseState === 'choose' && this.localStorageName) {
        let chooseObj = this.$localStorage.getItem(this.localStorageName)
          ? JSON.parse(this.$localStorage.getItem(this.localStorageName))
          : {
              cid: this.currCid,
              // date: this.localStorageSaveDate,
              chooseItemArr: [],
              chooseIdArr: [],
            }
        if (chooseObj.cid === this.currCid) {
          if (chooseObj.chooseItemArr.length === 0) {
            let newItem = JSON.parse(JSON.stringify(item))
            newItem.isChooseFlag = true
            chooseObj.chooseItemArr.push(newItem)
            chooseObj.chooseIdArr.push(item.chooseId)
          } else {
            let chooseItemArr = []
            let chooseIdArr = []
            chooseObj.chooseItemArr.forEach((chooseItem) => {
              if (chooseItem.chooseId !== item.chooseId) {
                chooseItemArr.push(chooseItem)
                chooseIdArr.push(chooseItem.chooseId)
              }
            })
            if (chooseItemArr.length === chooseObj.chooseItemArr.length) {
              let newItem = JSON.parse(JSON.stringify(item))
              newItem.isChooseFlag = true
              chooseItemArr.push(newItem)
              chooseIdArr.push(item.chooseId)
            }
            chooseObj.chooseItemArr = chooseItemArr
            chooseObj.chooseIdArr = chooseIdArr
          }
          this.$localStorage.setItem(
            this.localStorageName,
            JSON.stringify(chooseObj)
          )
          this.$emit('changeChooseNumEvent', {
            localStorageName: this.localStorageName,
            type: this.viewMode,
            val: chooseObj.chooseIdArr.length,
            init: false,
          })
          console.debug('chooseObj:', chooseObj)
        } else {
          console.error('错误：赛事不同')
        }
      } else if (this.detailPathName) {
        let currSportsDetail = {
          sportsId: item.sportsId,
          eventId: item.eventId,
          matchId: item.matchId,
          sportsName: item.sportsName,
          eventName: item.eventName,
          // matchDetail: item
        }
        console.debug('sportsDetail_compreScore:', currSportsDetail)
        this.$localStorage.setItem(
          'mixtmt_platfromV4_currSportsDetail',
          JSON.stringify(currSportsDetail)
        )
        let params = {
          cid: this.currCid,
          sid: item.seasonId ? item.seasonId : this.currSid,
          sportsId: item.sportsId,
          eventId: item.eventId,
          mid: item.matchId,
        }
        let detailPathName = ''
        if (typeof this.detailPathName === 'object') {
          // object
          // this.detailPathName = [
          //   {
          //     pathName: 'CBAScheduleDetailPreMatch',
          //     matchStatus: '1',
          //   },
          //   {
          //     pathName: 'CBAScheduleDetailPreMatch',
          //     matchStatus: '5',
          //   },
          //   {
          //     pathName: 'CBAScheduleDetailAnalysis',
          //     matchStatus: 'all',
          //   },
          // ]
          this.detailPathName.forEach((pathItem) => {
            if (item.matchStatus + '' === pathItem.matchStatus) {
              detailPathName = pathItem.pathName
            }
          })
          if (!detailPathName) {
            detailPathName =
              this.detailPathName[this.detailPathName.length - 1].pathName
          }
        } else {
          // string
          detailPathName = this.detailPathName
        }
        console.debug('detailPathName:', detailPathName)
        this.openNewWeb(this.$router, detailPathName, params)
      }
    },
    clickRightBtn(item, type) {
      this.$emit('clickRightBtnEvent', {
        item,
        type,
      })
    },
    _valPerFormatHandler(val, ceil) {
      let data
      if (val === undefined || val === null || val === '' || val === ' ') {
        return '-'
      }
      data = `${val}${ceil ? ceil : ''}`
      return data
    },
    _valTimeFormatHandler(val) {
      let data
      if (val === undefined || val === null || val === '' || val === ' ') {
        data = '00'
      } else {
        if (val - 0 <= 9) {
          data = `0${val}`
        }
        data = val
      }
      return data
    },
  },
}
</script>

<style lang="scss" scoped>
.mixtmt_pc,
.mixtmt_ipad {
  .comp_programList {
    width: 100%;
    height: auto;
    border-top: 1px solid var(--mixtmt_greyColor5);
    &.onlyDisplay {
      display: flex;
      display: -webkit-flex;
      align-items: center;
      flex-direction: column;
      height: 100%;
      border-top: 0;
      overflow-y: auto;
      &.alignCenter {
        justify-content: center;
      }
      &.alignTop {
        justify-content: flex-start;
      }
      .program_list_item {
        /* &:first-child {
              border-top: 1px solid var(--mixtmt_greyColor5);
            } */
      }
    }
    .program_list_item {
      position: relative;
      display: flex;
      display: -webkit-flex;
      justify-content: flex-start;
      align-items: flex-start;
      height: auto;
      width: 100%;
      padding: 1.388vw;
      color: var(--mixtmt_greyColor3);
      border-bottom: 1px solid var(--mixtmt_greyColor5);
      transition: padding 0.3s linear;
      &.choose {
        padding: 1.388vw 1.388vw 1.388vw 4.16vw;
        .item_absChoose {
          width: 4.16vw;
          display: flex;
          display: -webkit-flex;
          justify-content: center;
          align-items: center;
          .checkbox_item {
            width: 1.388vw;
            height: 1.388vw;
            border-radius: 0.208vw;
            border: 1px solid var(--mixtmt_subColor1_1);
            display: flex;
            display: -webkit-flex;
            justify-content: center;
            align-items: center;
            background-color: var(--mixtmt_whiteColor);
            /* &.act {
                        background-color: var(--mixtmt_subColor1_1);
                        color: var(--mixtmt_whiteColor);
                      } */
            svg {
              opacity: 0;
              fill: var(--mixtmt_whiteColor);
              transition: all 0.3s linear;
            }
          }
        }
        &.chooseAct {
          .checkbox_item {
            background-color: var(--mixtmt_subColor1_1);
            svg {
              opacity: 1;
            }
          }
        }
      }
      .matchLeft_colum1,
      .matchCenter_colum1 {
        display: flex;
        display: -webkit-flex;
        justify-content: space-between;
        align-items: flex-start;
        flex-direction: column;
        height: auto;
      }
      .item_matchLeft {
        display: flex;
        display: -webkit-flex;
        justify-content: flex-start;
        align-items: center;
        width: 9.74vw;
        .matchLeft_colum1 {
          width: 100%;
          .matchLeft_colum1_row1 {
            width: 100%;
            font-size: 1.11vw;
            line-height: 2.083vw;
            height: 2.083vw;
            font-weight: bold;
          }
          .matchLeft_colum1_row2 {
            display: flex;
            display: -webkit-flex;
            justify-content: flex-start;
            align-items: center;
            width: 100%;
            height: 2.083vw;
            font-size: 1.11vw;
            color: var(--mixtmt_greyColor2);
          }
        }
      }
      .item_matchCenter {
        display: flex;
        display: -webkit-flex;
        justify-content: space-between;
        align-items: center;
        width: calc(100% - 9.74vw - 6.94vw);
        .matchCenter_colum1 {
          width: 100%;
          .matchCenter_colum1_row {
            width: 100%;
            height: 2.083vw;
            display: flex;
            display: -webkit-flex;
            justify-content: flex-start;
            align-items: center;
            .delegationName {
              width: 100%;
              padding-left: 0.972vw;
              font-size: 0.972vw;
              /* font-weight: bold; */
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }
        }
      }
      .item_matchRight {
        position: absolute;
        right: 1.388vw;
        top: 50%;
        z-index: 10;
        transform: translateY(-50%);
        width: 6.94vw;
        display: flex;
        display: -webkit-flex;
        justify-content: flex-end;
        align-items: center;
        .matchRight_btn {
          width: 2.083vw;
          height: 2.083vw;
          text-align: center;
          border-radius: 50%;
          border: 1px solid var(--mixtmt_greyColor0);
          display: flex;
          display: -webkit-flex;
          justify-content: center;
          align-items: center;
          margin-right: 1.1vw;
          &:last-child {
            margin-right: 0;
          }
          .iconBox {
            /* opacity: 0;
              position: absolute;
              top: 0;
              left: 0;
              z-index: 2; */
            width: 100%;
            height: 100%;
            display: flex;
            display: -webkit-flex;
            justify-content: center;
            align-items: center;
            svg.svg_icon {
              fill: var(--mixtmt_greyColor2);
            }
          }
          &.unstart {
            color: var(--mixtmt_greyColor2);
            border: 1px solid var(--mixtmt_greyColor2);
          }
          &.playing {
            color: var(--mixtmt_subColor3_1);
            border: 1px solid var(--mixtmt_subColor3_1);
          }
          &.finished {
            color: var(--mixtmt_greyColor2);
            border: 1px solid var(--mixtmt_greyColor2);
          }
          &.other {
            background-color: var(--mixtmt_greyColor0);
            color: var(--mixtmt_greyColor2);
            border: 1px solid var(--mixtmt_greyColor0);
          }
        }
        .channelName {
          border: 1px solid var(--mixtmt_greyColor0);
          padding: 0.347vw 1.1vw;
          border-radius: 1.1vw;
          color: var(--mixtmt_greyColor2);
        }
      }
      .item_absChoose {
        position: absolute;
        left: 0;
        top: 0;
        z-index: 2;
        width: 0;
        height: 100%;
        transition: width 0.3s linear;
      }

      &.itemGreyColor {
        /* 赛程文字置灰，不可点击进入赛果 */
        /* color: var(--mixtmt_greyColor4); */
        opacity: 0.5;
      }
    }
  }
}

.mixtmt_pc {
  .comp_programList {
    .program_list_item:not(.none) {
      &:hover,
      &.choose.chooseAct {
        background-color: var(--mixtmt_scheduleItem_actBgColor);
        /* background-color: rgba(41, 68, 128, 0.1); */
        color: var(--mixtmt_whiteColor);
        .item_matchLeft {
          .matchLeft_colum1 {
            .matchLeft_colum1_row2 {
              color: var(--mixtmt_whiteColor);
            }
          }
        }
        .item_matchRight {
          .matchRight_btn {
            border: 1px solid var(--mixtmt_whiteColor);
            svg.svg_icon {
              fill: var(--mixtmt_whiteColor);
            }
            &:hover {
              background-color: var(--mixtmt_subColor1_1);
              /* border: 1px solid var(--mixtmt_mainColor); */
              cursor: pointer;
            }
          }
          .channelName {
            border: 1px solid var(--mixtmt_greyColor0);
            background-color: var(--mixtmt_whiteColor);
            color: var(--mixtmt_mainColor);
          }
        }
      }
      &.choose.chooseAct,
      &.choose {
        cursor: pointer;
      }
    }
  }
}
</style>
